import { ISequencePlay, Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TimelineMax, Timeline, TweenLite } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";

export enum dispTypes {
    TEXT = "String",
    SPINE = "Spine",
    SEQUENCE = "Sequence"
}

interface Poster{
    state:string;
    post:PosterType;
}

interface PosterType{
    type:string;
    obj:PIXI.spine.Spine | Sequence | PIXI.Text;
    play?:Function;
}

export interface ISpinePlay{
    animationName?: string;
    track?: number;
    loop?: boolean;
}

export interface PosterPlayerConfig{
    config:ISequencePlay | ISpinePlay;
}

export class PosterPlayer extends StateHandler{

    private missingAnimTxt:string = "Missing: ";

    private posters:Poster[] = [];
    private active_poster:Poster | undefined;

    private posterTimeline:TimelineMax;

    public get playingPoster():PIXI.DisplayObject | undefined{
        return this.active_poster?.post?.obj;
    }

    public load(posterStates:string[]):Poster[]{
        for(let b:number = 0; b < posterStates.length; b++){
            this.posters.push({state:posterStates[b], post: this.define(posterStates[b])})
        }
        return this.posters;
    }

    private define(sType:string):PosterType{
        try{
            let spine = new PIXI.spine.Spine(GameResources.getSpineAsset(sType))
            return {obj:spine, type:dispTypes.SPINE };
        }catch(e){}
        if(PIXI.utils.TextureCache[sType]){
            const seq:Sequence = Sequence.createSequence(GameResources.getTextures(sType));
            return {obj:seq, type:dispTypes.SEQUENCE};
        }
        else{
            const text:PIXI.Text = this.createText(this.missingAnimTxt + sType, TextStyleConfig.MISSING_TEXT);
            return {obj: text, type:dispTypes.TEXT};
        }
    }

    private createText(text:string, style:TextStyleOptions):PIXI.Text {
        const textField = new PIXI.Text(text, style);
        textField.anchor.set(0.5, 0.5);
        return textField;
    }

    public poster(state?:string):void{
        if(state !== undefined && !this.equal(state)){
            super.set(state);
            this.active_poster = this.posters.find((p) => { return p.state == state });
        }
    }

    public getDuration():number{
        if(!this.active_poster){
            Logger.warn("noPoster");
            return 1;
        } 
        switch(this.active_poster.post.type){
            case dispTypes.SEQUENCE:
                const seq:Sequence = <Sequence>this.active_poster.post.obj;
                return seq.totalDuration;
            case dispTypes.SPINE:
                const spine:PIXI.spine.Spine = <PIXI.spine.Spine>this.active_poster.post.obj;
                return spine.spineData.animations[0].duration;
            default:
                return 1;
        }
    }

    public play(conf?:PosterPlayerConfig):TimelineMax{
        this.posterTimeline = Helper.timeLineKiller(this.posterTimeline, new TimelineMax());
        if(!this.active_poster){
            Logger.warn("noPoster");
            return this.posterTimeline;
        } 
        this.resetPoster();
        switch(this.active_poster.post.type){
            case dispTypes.SEQUENCE:
                const seqConf:ISequencePlay | undefined = <ISequencePlay>conf?.config;
                const seq:Sequence = <Sequence>this.active_poster.post.obj;
                this.posterTimeline.add([
                    seq.visible = true,
                    seq.playAnimation(seqConf)
                ]);
                break;
            case dispTypes.SPINE:
                const spineConf:ISpinePlay | undefined = <ISpinePlay>conf!.config;
                const spine:PIXI.spine.Spine = <PIXI.spine.Spine>this.active_poster.post.obj;
                const track =  spine.state.addAnimation(spineConf.track === undefined ? 0: spineConf.track , spineConf.animationName ? spineConf.animationName : this.active_poster.state , !!spineConf.loop,0);
                this.posterTimeline.add([
                    () => spine.visible = true,
                    TweenLite.to(this,track.animationEnd,{})
                ])
                break;
            default:
                const textConf:ISequencePlay | undefined = <ISequencePlay>conf?.config;
                const txt:PIXI.Text = <PIXI.Text>this.active_poster.post.obj;
                this.posterTimeline.add(() => txt.visible = true)
                break;
        }
        return this.posterTimeline;
    }

    public stop():void{
        this.posterTimeline = Helper.timeLineKiller(this.posterTimeline);
        this.resetPoster();
    }

    private resetPoster():void{
        if(!this.active_poster) return;
        this.active_poster.post.obj.visible = false;
        // this.active_poster.post.obj.alpha = 1;
        switch(this.active_poster.post.type){
            case dispTypes.SEQUENCE:
                const seq:Sequence = <Sequence>this.active_poster.post.obj;
                seq.reset();
                break;
            case dispTypes.SPINE:
                const par:PIXI.Container = <PIXI.spine.Spine>this.active_poster.post.obj.parent;
                (<PIXI.spine.Spine>this.active_poster.post.obj).destroy({children:true});
                par.removeChild(this.active_poster.post.obj);
                this.active_poster.post.obj = <PIXI.spine.Spine>par.addChild(this.define(this.state).obj);
                break;
            default:
                break;
        }
    }
}
